/**
 * Navigation vers un onglet depuis l'extérieur de `Tabs` — les liens rapides du
 * panneau identité (« Tarifs », « Nos avis »).
 *
 * La version précédente posait `window.location.hash` et laissait l'écouteur
 * `hashchange` de `Tabs` activer l'onglet, puis défilait dans un
 * `requestAnimationFrame`. `hashchange` est livré dans une **tâche** dont
 * l'ordre par rapport à la frame suivante n'est pas garanti : Chrome exécutait
 * le rAF d'abord, donc `scrollIntoView()` tombait sur un panneau encore
 * `hidden` (`display:none`, boîte nulle) — un no-op silencieux. Seul l'onglet
 * déjà actif (« Tarifs ») défilait, les autres ne faisaient que changer de tab.
 *
 * On ne demande donc plus rien au navigateur : l'intention est diffusée telle
 * quelle, et c'est `Tabs` — le seul à savoir quand React a réellement affiché
 * le panneau — qui active puis défile, après commit.
 */
export const TAB_NAV_EVENT = 'tchip:go-to-tab';

export const goToTab = (tabId) => {
  if (typeof document === 'undefined') return;
  document.dispatchEvent(new CustomEvent(TAB_NAV_EVENT, { detail: { tabId } }));
};

export default goToTab;
